import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE } from '@angular/core';

import { HttpModule } from '@angular/http';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { AppSettings } from './services/constants/constants';

//Additional 
//Model
import { NgbModule, NgbDate } from '@ng-bootstrap/ng-bootstrap';
//progress bar
import { NgProgressModule } from '@ngx-progressbar/core'
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
//Toast Service
import { ToastrModule } from 'ngx-toastr';
//Select drop down
import { NgSelectModule } from '@ng-select/ng-select';

import { QRCodeModule } from 'angularx-qrcode';

//Map
// import { AgmCoreModule } from '@agm/core';
// import { AgmDirectionModule } from 'agm-direction';
//EDITOR
import { CKEditorModule } from 'ngx-ckeditor';
//Table
//import { DataTablesModule } from 'angular-datatables';
//Date Pikker
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {  TimepickerModule } from 'ngx-bootstrap/timepicker';
//Image Compress
//import { NgxImageCompressService } from 'ngx-image-compress';
//import { Ng2ImgMaxModule } from 'ng2-img-max';
//Barcode
//import { NgxBarcodeModule } from 'ngx-barcode';
//Sidebar
import { SidebarModule } from 'ng-sidebar';
//Device Info
//import { DeviceDetectorModule } from 'ngx-device-detector';
//Currency
import { CurrencyMaskModule, CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask";




// //Firebase
// // import {AngularFireModule} from 'angularfire2'
// // import {AngularFireDatabaseModule} from 'angularfire2/database'
// import { AngularFireModule } from '@angular/fire';
// import { AngularFireDatabaseModule } from '@angular/fire/database';

//Chart
//import { NgxChartsModule } from '@swimlane/ngx-charts';
//import { HighchartsChartModule } from 'highcharts-angular';
//Drag
//import { DragDropModule } from '@angular/cdk/drag-drop';

//Ag Grid
//import { AgGridModule } from 'ag-grid-angular';

//import { NgxEmojiPickerModule } from 'ngx-emoji-picker';

import { NgxMaskModule, IConfig } from 'ngx-mask'


import { NgxPaginationModule } from 'ngx-pagination';

import { Ng2SearchPipeModule } from 'ng2-search-filter';

//import {NgxPrintModule} from 'ngx-print';

//Session
import { BnNgIdleService } from 'bn-ng-idle';
//Component
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HeaderComponent } from './header/header.component';

// service
import { DhukanDataService } from './services/dhukan/dhukan-data.service';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './components/confirmation-dialog/confirmation-dialog.service';


import { TwoDigitDecimaNumberDirectiveDirective } from './two-digit-decima-number-directive.directive';
import { LoginComponent } from './components/login/login.component';
import { DateFormatPipe } from './date-format.pipe';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DatetimeFormatPipe } from './datetime-format.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { DisablecontrolDirective } from './disablecontrol.directive';
import { HttpcancelService } from './services/dhukan/httpcancel.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ManageHttpInterceptor } from './interceptor/managehttp.interceptor';

import { environment } from 'src/environments/environment';
// import { AngularFirestore } from '@angular/fire/firestore/angular-fire-firestore';
import { ImageformatterComponent } from './components/grid/imageformatter/imageformatter.component';
import { ButtonformatterComponent } from './components/grid/buttonformatter/buttonformatter.component';
import { ActionformatterComponent } from './components/grid/actionformatter/actionformatter.component';


import { RestaurantComponent } from './components/restaurant/restaurant.component';
import { AddrestaurantComponent } from './components/restaurant/addrestaurant/addrestaurant.component';
import { CategoryComponent } from './components/category/category.component';
import { AddcategoryComponent } from './components/category/addcategory/addcategory.component';
import { SubcategoryComponent } from './components/subcategory/subcategory.component';
import { AddsubcategoryComponent } from './components/subcategory/addsubcategory/addsubcategory.component';
import { UserComponent } from './components/user/user.component';
import { AdduserComponent } from './components/user/adduser/adduser.component';
import { ProductComponent } from './components/product/product.component';
import { AddproductComponent } from './components/product/addproduct/addproduct.component';
import { UserroleComponent } from './components/userrole/userrole.component';
import { AdduserroleComponent } from './components/userrole/adduserrole/adduserrole.component';



import { AddcategorypopupComponent } from './components/generalpopup/addcategorypopup/addcategorypopup.component';
import { AddsubcategorypopupComponent } from './components/generalpopup/addsubcategorypopup/addsubcategorypopup.component';

import { NgMaskCusDirectiveDirective } from './ng_mask_cus-directive.directive';
import { RenogridComponent } from './components/grid/renogrid/renogrid.component';
import { SortDirective } from './sort.directive';
import { QuestionComponent } from './components/question/question.component';
import { AddquestionComponent } from './components/question/addquestion/addquestion.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { AddfeedbackComponent } from './components/feedback/addfeedback/addfeedback.component';
import { AddbranchComponent } from './components/branch/addbranch/addbranch.component';
import { BranchComponent } from './components/branch/branch.component';
import { BrandComponent } from './components/brand/brand.component';
import { AddbrandComponent } from './components/brand/addbrand/addbrand.component';
import { CardtypeComponent } from './components/cardtype/cardtype.component';
import { AddcardtypeComponent } from './components/cardtype/addcardtype/addcardtype.component';
import { CompanyComponent } from './components/company/company.component';
import { AddcompanyComponent } from './components/company/addcompany/addcompany.component';
import { CourseComponent } from './components/course/course.component';
import { AddcourseComponent } from './components/course/addcourse/addcourse.component';
import { CuisineComponent } from './components/cuisine/cuisine.component';
import { AddcuisineComponent } from './components/cuisine/addcuisine/addcuisine.component';
import { DepartmentComponent } from './components/department/department.component';
import { AdddepartmentComponent } from './components/department/adddepartment/adddepartment.component';
import { DinetypeComponent } from './components/dinetype/dinetype.component';
import { AdddinetypeComponent } from './components/dinetype/adddinetype/adddinetype.component';
import { GroupComponent } from './components/group/group.component';
import { AddgroupComponent } from './components/group/addgroup/addgroup.component';
import { SubgroupComponent } from './components/subgroup/subgroup.component';
import { AddsubgroupComponent } from './components/subgroup/addsubgroup/addsubgroup.component';
import { ModifierComponent } from './components/modifier/modifier.component';
import { AddmodifierComponent } from './components/modifier/addmodifier/addmodifier.component';
import { ModifiertypeComponent } from './components/modifiertype/modifiertype.component';
import { AddmodifiertypeComponent } from './components/modifiertype/addmodifiertype/addmodifiertype.component';
import { OrdermodeComponent } from './components/ordermode/ordermode.component';
import { AddordermodeComponent } from './components/ordermode/addordermode/addordermode.component';
import { PartyComponent } from './components/party/party.component';
import { AddpartyComponent } from './components/party/addparty/addparty.component';
import { PaymentmodeComponent } from './components/paymentmode/paymentmode.component';
import { AddpaymentmodeComponent } from './components/paymentmode/addpaymentmode/addpaymentmode.component';
import { ReasonComponent } from './components/reason/reason.component';
import { AddreasonComponent } from './components/reason/addreason/addreason.component';
import { ShiftComponent } from './components/shift/shift.component';
import { AddshiftComponent } from './components/shift/addshift/addshift.component';
import { SizeComponent } from './components/size/size.component';
import { AddsizeComponent } from './components/size/addsize/addsize.component';
import { TaxComponent } from './components/tax/tax.component';
import { AddtaxComponent } from './components/tax/addtax/addtax.component';
import { UomComponent } from './components/uom/uom.component';
import { AdduomComponent } from './components/uom/adduom/adduom.component';
import { StationComponent } from './components/station/station.component';
import { AddstationComponent } from './components/station/addstation/addstation.component';
import { TablesectionComponent } from './components/tablesection/tablesection.component';
import { AddtablesectionComponent } from './components/tablesection/addtablesection/addtablesection.component';
import { TableComponent } from './components/table/table.component';
import { AddtableComponent } from './components/table/addtable/addtable.component';
import { FoodsymbolComponent } from './components/foodsymbol/foodsymbol.component';
import { AddfoodsymbolComponent } from './components/foodsymbol/addfoodsymbol/addfoodsymbol.component';
import { LocalityComponent } from './components/locality/locality.component';
import { AddlocalityComponent } from './components/locality/addlocality/addlocality.component';
import { ProductviewComponent } from './components/product/productview/productview.component';
import { BranchviewComponent } from './components/branch/branchview/branchview.component';
import { ProductvariationComponent } from './components/product/productvariation/productvariation.component';
import { OpenshiftComponent } from './components/openshift/openshift.component';
import { SettingsComponent } from './components/settings/settings.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { AddcurrencyComponent } from './components/currency/addcurrency/addcurrency.component';
import { AdddenominationComponent } from './components/currency/adddenomination/adddenomination.component';
import { NumberpadComponent } from './components/grid/numberpad/numberpad.component';
import { IncomeComponent } from './components/income/income.component';
import { AddincomeComponent } from './components/income/addincome/addincome.component';
import { ChargesComponent } from './components/charges/charges.component';
import { AddchargesComponent } from './components/charges/addcharges/addcharges.component';
import { ExpenseComponent } from './components/expense/expense.component';
import { AddexpenseComponent } from './components/expense/addexpense/addexpense.component';
import { VoucherComponent } from './components/voucher/voucher.component';
import { AddvoucherComponent } from './components/voucher/addvoucher/addvoucher.component';
import { ReportComponent } from './components/report/report.component';
import { OpenbillreportComponent } from './components/report/openbillreport/openbillreport.component';
import { ProductquickmenuComponent } from './components/productquickmenu/productquickmenu.component';
import { AddproductquickmenuComponent } from './components/productquickmenu/addproductquickmenu/addproductquickmenu.component';
import { ActivitylogreportComponent } from './components/report/activitylogreport/activitylogreport.component';
import { ShiftcloseemailComponent } from './components/shiftcloseemail/shiftcloseemail.component';
import { AddshiftcloseemailComponent } from './components/shiftcloseemail/addshiftcloseemail/addshiftcloseemail.component';
import { DinetypereportComponent } from './components/report/dinetypereport/dinetypereport.component';
import { ProductreportComponent } from './components/report/productreport/productreport.component';
import { GroupreportComponent } from './components/report/groupreport/groupreport.component';
import { DailyreportComponent } from './components/report/dailyreport/dailyreport.component';
import { EmployeeComponent } from './components/employee/employee.component';
import { AddemployeeComponent } from './components/employee/addemployee/addemployee.component';
import { TestComponent } from './components/test/test.component';
import { ImportproductComponent } from './components/product/importproduct/importproduct.component';
import { ProcessComponent } from './components/process/process.component';
import { PurchaseComponent } from './componentstransaction/purchase/purchase.component';
import { AddpurchaseComponent } from './componentstransaction/purchase/addpurchase/addpurchase.component';
import { AdjtypeComponent } from './components/adjtype/adjtype.component';
import { AddadjtypeComponent } from './components/adjtype/addadjtype/addadjtype.component';
import { AdjComponent } from './componentstransaction/adj/adj.component';
import { AddadjComponent } from './componentstransaction/adj/addadj/addadj.component';
import { PhysicalstockComponent } from './componentstransaction/physicalstock/physicalstock.component';
import { AddphysicalstockComponent } from './componentstransaction/physicalstock/addphysicalstock/addphysicalstock.component';
import { StockreportComponent } from './components/report/stockreport/stockreport.component';
import { PurchasereportComponent } from './components/report/purchasereport/purchasereport.component';
import { AdjreportComponent } from './components/report/adjreport/adjreport.component';
import { ProductpriceComponent } from './components/productprice/productprice.component';
import { ProductcancelreportComponent } from './components/report/productcancelreport/productcancelreport.component';
import { BillcancelreportComponent } from './components/report/billcancelreport/billcancelreport.component';
import { BillsummaryreportComponent } from './components/report/billsummaryreport/billsummaryreport.component';
import { TaxsummaryreportComponent } from './components/report/taxsummaryreport/taxsummaryreport.component';
import { SalesxreportComponent } from './components/report/salesxreport/salesxreport.component';
import { IncometypeComponent } from './components/incometype/incometype.component';
import { AddincometypeComponent } from './components/incometype/addincometype/addincometype.component';
import { ExpensetypeComponent } from './components/expensetype/expensetype.component';
import { AddexpensetypeComponent } from './components/expensetype/addexpensetype/addexpensetype.component';
import { IncomereportComponent } from './components/report/incomereport/incomereport.component';
import { ExpensereportComponent } from './components/report/expensereport/expensereport.component';
import { HourlyitemsalesreportComponent } from './components/report/hourlyitemsalesreport/hourlyitemsalesreport.component';
import { PaymentwiseorderreportComponent } from './components/report/paymentwiseorderreport/paymentwiseorderreport.component';
import { StationwisereportComponent } from './components/report/stationwisereport/stationwisereport.component';
import { ViewpartyComponent } from './components/party/viewparty/viewparty.component';
import { TablesectionviewComponent } from './components/tablesection/tablesectionview/tablesectionview.component';
import { PricetypeComponent } from './components/pricetype/pricetype.component';
import { AddpricetypeComponent } from './components/pricetype/addpricetype/addpricetype.component';
import { KitchennotesComponent } from './components/kitchennotes/kitchennotes.component';
import { AddkitchennotesComponent } from './components/kitchennotes/addkitchennotes/addkitchennotes.component';
import { ItemcategoryComponent } from './components/itemcategory/itemcategory.component';
import { AdditemcategoryComponent } from './components/itemcategory/additemcategory/additemcategory.component';
import { RawmaterialComponent } from './components/rawmaterial/rawmaterial.component';
import { AddrawmaterialComponent } from './components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { GroupbyPipe } from './groupby.pipe';
import { PurchasereturnComponent } from './componentstransaction/purchasereturn/purchasereturn.component';
import { AddpurchasereturnComponent } from './componentstransaction/purchasereturn/addpurchasereturn/addpurchasereturn.component';
import { TextSearchPipePipe } from './text-search-pipe.pipe';
import { GrdFilterPipe } from './grd-filter.pipe';
import { ReportgridComponent } from './components/grid/reportgrid/reportgrid.component';
import { FieldsumPipe } from './fieldsum.pipe';
import { SearchPipe } from './search.pipe';
import { ExportgridComponent } from './components/grid/exportgrid/exportgrid.component';
import { OrdermodereportComponent } from './components/report/ordermodereport/ordermodereport.component';
import { DiscountreportComponent } from './components/report/discountreport/discountreport.component';
import { PaymentmodereportComponent } from './components/report/paymentmodereport/paymentmodereport.component';
import { TablesectionreportComponent } from './components/report/tablesectionreport/tablesectionreport.component';
import { TablereportComponent } from './components/report/tablereport/tablereport.component';
import { CustomerreportComponent } from './components/report/customerreport/customerreport.component';
import { BillcancelsummaryreportComponent } from './components/report/billcancelsummaryreport/billcancelsummaryreport.component';
import { LocalityreportComponent } from './components/report/localityreport/localityreport.component';
import { ComplimentoryreportComponent } from './components/report/complimentoryreport/complimentoryreport.component';
import { FastmovingreportComponent } from './components/report/fastmovingreport/fastmovingreport.component';
import { VariationreportComponent } from './components/report/variationreport/variationreport.component';
import { CashierreportComponent } from './components/report/cashierreport/cashierreport.component';
import { WaiterreportComponent } from './components/report/waiterreport/waiterreport.component';
import { RecipeComponent } from './components/recipe/recipe.component';
import { AddrecipeComponent } from './components/recipe/addrecipe/addrecipe.component';
import { ReceiptsettingsComponent } from './components/receiptsettings/receiptsettings.component';
import { LoginDataService } from './services/dhukan/login-data.service';
import { ExportService } from './services/dhukan/export.service';
import { FocusScrollDirective } from './focus-scroll.directive';
import { SelectKeyboardDirective } from './select-keyboard.directive';
import { AddpurchasedetailsComponent } from './componentstransaction/purchase/addpurchasedetails/addpurchasedetails.component';
import { SupportComponent } from './components/support/support.component';
import { ViewsupportComponent } from './components/support/viewsupport/viewsupport.component';
import { DevicesComponent } from './components/devices/devices.component';
import { AdddevicesComponent } from './components/devices/adddevices/adddevices.component';
import { ConfigrationComponent } from './components/configration/configration.component';
import { OutletsettingsComponent } from './components/outletsettings/outletsettings.component';
import { AddpurchasereturndetailComponent } from './componentstransaction/purchasereturn/addpurchasereturndetail/addpurchasereturndetail.component';
import { AddadjdetailComponent } from './componentstransaction/adj/addadjdetail/addadjdetail.component';
import { AddexpensedetailComponent } from './components/expense/addexpensedetail/addexpensedetail.component';
import { AddicomedetailComponent } from './components/income/addicomedetail/addicomedetail.component';
import { AddrecipedetailComponent } from './components/recipe/addrecipedetail/addrecipedetail.component';
import { EditprofileComponent } from './components/user/editprofile/editprofile.component';
import { SalesquickviewComponent } from './components/report/salesquickview/salesquickview.component';
import { OutletselectionComponent } from './components/grid/outletselection/outletselection.component';
import { PosexpiryComponent } from './components/grid/posexpiry/posexpiry.component';
import { DashboardorganizationComponent } from './dashboardorganization/dashboardorganization.component';
import { DecimalSeparatorPipe } from './decimal-separator.pipe';
import { CurrencyProxyPipe } from './currencyproxy.pipe';
import { DmaskDirective } from './dmask.directive';
import { TableqrComponent } from './components/tablesection/tableqr/tableqr.component';
import { SalesactivitylogreportComponent } from './components/report/salesactivitylogreport/salesactivitylogreport.component';
import { TabledesignviewComponent } from './components/tablesection/tabledesignview/tabledesignview.component';
import { AccounttypeComponent } from './components/accounttype/accounttype.component';
import { AddaccounttypeComponent } from './components/accounttype/addaccounttype/addaccounttype.component';
import { AccountComponent } from './components/account/account.component';
import { AddaccountComponent } from './components/account/addaccount/addaccount.component';
import { SubledgertypeComponent } from './components/subledgertype/subledgertype.component';
import { SubledgerComponent } from './components/subledger/subledger.component';
import { AddsubledgerComponent } from './components/subledger/addsubledger/addsubledger.component';
import { AddsubledgertypeComponent } from './components/subledgertype/addsubledgertype/addsubledgertype.component';
import { CostcenterComponent } from './components/costcenter/costcenter.component';
import { AddcostcenterComponent } from './components/costcenter/addcostcenter/addcostcenter.component';

import { AddjournalvoucherComponent } from './componentstransaction/journalvoucher/addjournalvoucher/addjournalvoucher.component';
import { JournalvoucherComponent } from './componentstransaction/journalvoucher/journalvoucher.component';
import { DefaultledgerComponent } from './components/defaultledger/defaultledger.component';
import { AccountsreportComponent } from './components/report/accountsreport/accountsreport.component';
import { BalancesheetreportComponent } from './components/report/balancesheetreport/balancesheetreport.component';
import { TrailbalancereportComponent } from './components/report/trailbalancereport/trailbalancereport.component';
import { ProfitlossreportComponent } from './components/report/profitlossreport/profitlossreport.component';
import { PayablereportComponent } from './components/report/payablereport/payablereport.component';
import { ReceivablereportComponent } from './components/report/receivablereport/receivablereport.component';
import { PaymentComponent } from './componentstransaction/payment/payment.component';
import { AddpaymentComponent } from './componentstransaction/payment/addpayment/addpayment.component';
import { LpoComponent } from './componentstransaction/lpo/lpo.component';
import { AddlpoComponent } from './componentstransaction/lpo/addlpo/addlpo.component';
import { TransferComponent } from './componentstransaction/transfer/transfer.component';
import { AddtransferComponent } from './componentstransaction/transfer/addtransfer/addtransfer.component';
import { TemplatesettingsComponent } from './components/templatesettings/templatesettings.component';
import { AddpurchaseaccountsComponent } from './componentstransaction/purchase/addpurchaseaccounts/addpurchaseaccounts.component';
import { CustomerstatementreportComponent } from './components/report/customerstatementreport/customerstatementreport.component';
import { StockrangereportComponent } from './components/report/stockrangereport/stockrangereport.component';
import { DailyshiftreportComponent } from './components/report/dailyshiftreport/dailyshiftreport.component';
import { OutletshiftclosereportComponent } from './components/report/outletshiftclosereport/outletshiftclosereport.component';
import { OutletnewcustomerreportComponent } from './components/report/outletnewcustomerreport/outletnewcustomerreport.component';
import { OutletcustomerfootfallreportComponent } from './components/report/outletcustomerfootfallreport/outletcustomerfootfallreport.component';
import { ExpensedetailsreportComponent } from './components/report/expensedetailsreport/expensedetailsreport.component';
import { XferComponent } from './componentstransaction/xfer/xfer/xfer.component';
import { AddxferComponent } from './componentstransaction/xfer/addxfer/addxfer.component';
import { OutletwisesalesreportComponent } from './components/report/outletwisesalesreport/outletwisesalesreport.component';






export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}


// export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
//   align: "left",
//   allowNegative: true,
  //   decimal: ".",
//   precision: 2,
//   prefix: " ",
//   suffix: "",
//   thousands: ""
// };


export const customCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: ".",
  precision: 3,
  prefix: " ",
  suffix: "",
  thousands: ""
};


const maskConfig: Partial<IConfig> = {
  validation: false,
  thousandSeparator: "",
  separatorLimit: "9999999999",
  allowNegativeNumbers: false,
  dropSpecialCharacters: false,
  patterns: {
    'V': { pattern: new RegExp('-?') },
    '0': { pattern: new RegExp('[0-9]') }
  }
};


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    NavigationComponent,
    HeaderComponent,
    ConfirmationDialogComponent,
    TwoDigitDecimaNumberDirectiveDirective,
    LoginComponent,
    DateFormatPipe,
    DatetimeFormatPipe,
    LoadingComponent,
    DisablecontrolDirective,
    ImageformatterComponent,
    ButtonformatterComponent,
    ActionformatterComponent,
    RestaurantComponent,
    AddrestaurantComponent,
    CategoryComponent,
    AddcategoryComponent,
    SubcategoryComponent,
    AddsubcategoryComponent,
    UserComponent,
    AdduserComponent,
    ProductComponent,
    AddproductComponent,
    UserroleComponent,
    AdduserroleComponent,
    AddcategorypopupComponent,
    AddsubcategorypopupComponent,

    NgMaskCusDirectiveDirective,
    RenogridComponent,
    SortDirective,
    QuestionComponent,
    AddquestionComponent,
    FeedbackComponent,
    AddfeedbackComponent,
    BranchComponent,
    AddbranchComponent,
    BrandComponent,
    AddbrandComponent,
    CardtypeComponent,
    AddcardtypeComponent,
    CompanyComponent,
    AddcompanyComponent,
    CourseComponent,
    AddcourseComponent,
    CuisineComponent,
    AddcuisineComponent,
    DepartmentComponent,
    AdddepartmentComponent,
    DinetypeComponent,
    AdddinetypeComponent,
    GroupComponent,
    AddgroupComponent,
    SubgroupComponent,
    AddsubgroupComponent,
    ModifierComponent,
    AddmodifierComponent,
    ModifiertypeComponent,
    AddmodifiertypeComponent,
    OrdermodeComponent,
    AddordermodeComponent,
    PartyComponent,
    AddpartyComponent,
    PaymentmodeComponent,
    AddpaymentmodeComponent,
    ReasonComponent,
    AddreasonComponent,
    ShiftComponent,
    AddshiftComponent,
    SizeComponent,
    AddsizeComponent,
    TaxComponent,
    AddtaxComponent,
    UomComponent,
    AdduomComponent,
    StationComponent,
    AddstationComponent,
    TablesectionComponent,
    AddtablesectionComponent,
    TableComponent,
    AddtableComponent,
    FoodsymbolComponent,
    AddfoodsymbolComponent,
    LocalityComponent,
    AddlocalityComponent,
    ProductviewComponent,
    BranchviewComponent,
    ProductvariationComponent,
    OpenshiftComponent,
    SettingsComponent,
    CurrencyComponent,
    AddcurrencyComponent,
    AdddenominationComponent,   
    NumberpadComponent,    
    IncomeComponent,
    AddincomeComponent,
    ChargesComponent,
    AddchargesComponent,
    ExpenseComponent,
    AddexpenseComponent,
    VoucherComponent,
    AddvoucherComponent,
    ReportComponent,
    OpenbillreportComponent,
    ProductquickmenuComponent,
    AddproductquickmenuComponent,
    ActivitylogreportComponent,
    ShiftcloseemailComponent,
    AddshiftcloseemailComponent,
    DinetypereportComponent,
    ProductreportComponent,
    GroupreportComponent,
    DailyreportComponent,
    EmployeeComponent,
    AddemployeeComponent,
    ImportproductComponent,
    TestComponent,
    ProcessComponent,
    PurchaseComponent,
    AddpurchaseComponent,
    AdjtypeComponent,
    AddadjtypeComponent,
    AdjComponent,
    AddadjComponent,
    PhysicalstockComponent,
    AddphysicalstockComponent,
    StockreportComponent,
    PurchasereportComponent,
    AdjreportComponent,
    ProductpriceComponent,
    ProductcancelreportComponent,
    BillcancelreportComponent,
    BillsummaryreportComponent,
    TaxsummaryreportComponent,
    SalesxreportComponent,
    IncometypeComponent,
    AddincometypeComponent,
    ExpensetypeComponent,
    AddexpensetypeComponent,
    IncomereportComponent,
    ExpensereportComponent,
    HourlyitemsalesreportComponent,
    PaymentwiseorderreportComponent,
    StationwisereportComponent,
    ViewpartyComponent,
    TablesectionviewComponent,
    PricetypeComponent,
    AddpricetypeComponent,
    KitchennotesComponent,
    AddkitchennotesComponent,
    ItemcategoryComponent,
    AdditemcategoryComponent,
    RawmaterialComponent,
    AddrawmaterialComponent,
    GroupbyPipe,
    PurchasereturnComponent,
    AddpurchasereturnComponent,
    TextSearchPipePipe,
    GrdFilterPipe,
    ReportgridComponent,
    FieldsumPipe,
    SearchPipe,
    ExportgridComponent,
    OrdermodereportComponent,
    DiscountreportComponent,
    PaymentmodereportComponent,
    TablesectionreportComponent,
    TablereportComponent,
    CustomerreportComponent,
    BillcancelsummaryreportComponent,
    LocalityreportComponent,
    ComplimentoryreportComponent,
    FastmovingreportComponent,
    VariationreportComponent,
    CashierreportComponent,
    WaiterreportComponent,
    RecipeComponent,
    AddrecipeComponent,
    ReceiptsettingsComponent,
    FocusScrollDirective,
    SelectKeyboardDirective,
    AddpurchasedetailsComponent,
    SupportComponent,
    ViewsupportComponent,
    DevicesComponent,
    AdddevicesComponent,
    ConfigrationComponent,
    OutletsettingsComponent,
    AddpurchasereturndetailComponent,
    AddadjdetailComponent,
    AddexpensedetailComponent,
    AddicomedetailComponent,
    AddrecipedetailComponent,
    EditprofileComponent,
    SalesquickviewComponent,
    OutletselectionComponent,
    PosexpiryComponent,
    DashboardorganizationComponent,
    DecimalSeparatorPipe,
    CurrencyProxyPipe,
    DmaskDirective,
    TableqrComponent,
    SalesactivitylogreportComponent,
    TabledesignviewComponent,
    AccounttypeComponent,
    AddaccounttypeComponent,
    AccountComponent,
    AddaccountComponent,
    SubledgertypeComponent,
    SubledgerComponent,
    AddsubledgerComponent,
    AddsubledgertypeComponent,
    CostcenterComponent,
    AddcostcenterComponent,
    JournalvoucherComponent,
    AddjournalvoucherComponent,
    DefaultledgerComponent,
    AccountsreportComponent,
    BalancesheetreportComponent,
    TrailbalancereportComponent,
    ProfitlossreportComponent,
    PayablereportComponent,
    ReceivablereportComponent,
    PaymentComponent,
    AddpaymentComponent,
    LpoComponent,
    AddlpoComponent,
    TransferComponent,
    AddtransferComponent,
    TemplatesettingsComponent,
    AddpurchaseaccountsComponent,
    CustomerstatementreportComponent,
    StockrangereportComponent,
    DailyshiftreportComponent,
    OutletshiftclosereportComponent,
    OutletnewcustomerreportComponent,
    OutletcustomerfootfallreportComponent,
    ExpensedetailsreportComponent,
    XferComponent,
    AddxferComponent,
    OutletwisesalesreportComponent,

    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgProgressModule,
    NgProgressHttpModule,
    NgProgressRouterModule,
    NgSelectModule,
    //DragDropModule,
   
    //DataTablesModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    //Ng2ImgMaxModule,
    //NgxBarcodeModule,
    //NgxPrintModule,
    SidebarModule.forRoot(),
    //DeviceDetectorModule.forRoot(),
    //NgxEmojiPickerModule.forRoot(),
    CurrencyMaskModule,
    NgxMaskModule.forRoot(maskConfig),
    ToastrModule.forRoot({
      timeOut: 500,
      positionClass: 'toast-top-center'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    // AgmCoreModule.forRoot({
    //   apiKey: "AIzaSyClUICP4-qGf2r4SSCZF5MzbSFXT6mIbvM",
    //   libraries: ["places"]
    // }),
    QRCodeModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,    
    //HighchartsChartModule,
    //NgxChartsModule,
    //AgmDirectionModule,
    //AngularFireModule.initializeApp(AppSettings.firebaseConfig),
    //AngularFireDatabaseModule,
   // AgGridModule.withComponents([ImageformatterComponent, ButtonformatterComponent])
   CKEditorModule,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  // providers: [LoginDataService,DhukanDataService,ExportService , DatePipe,DateFormatPipe, Location],  
  providers: [DatePipe, Location, { provide: LocationStrategy, useClass: PathLocationStrategy },DecimalSeparatorPipe],
  bootstrap: [AppComponent],
  exports: [BrowserModule, TranslateModule],
  entryComponents: [RenogridComponent, ConfirmationDialogComponent,  AddcategorypopupComponent, AddsubcategorypopupComponent, AddcardtypeComponent,
    AddrestaurantComponent, AddproductComponent, AddfeedbackComponent, AddbranchComponent, AddbrandComponent, AddcourseComponent, AdddepartmentComponent, AdddinetypeComponent,
    AddcuisineComponent, AddgroupComponent, AddsubgroupComponent, AddmodifierComponent, AddmodifiertypeComponent, AddordermodeComponent, AddpartyComponent, AddpaymentmodeComponent,
    AddreasonComponent, AddshiftComponent, AddsizeComponent, AdduomComponent, AddtaxComponent, AddstationComponent, AddtablesectionComponent, AddtableComponent, AddfoodsymbolComponent,
    AddlocalityComponent, ProductvariationComponent, OpenshiftComponent, AdddenominationComponent, AddcurrencyComponent,AddincomeComponent,AddchargesComponent,
    AddexpenseComponent,AddvoucherComponent,AddproductquickmenuComponent,AddshiftcloseemailComponent,AddemployeeComponent,ImportproductComponent,AddpurchaseComponent,
    AddadjtypeComponent, AddadjComponent, AddphysicalstockComponent, AddpricetypeComponent, AddpurchasereturnComponent, AddpurchasereturndetailComponent, AddexpensedetailComponent, AddicomedetailComponent,
    ExportgridComponent, AddrecipeComponent,AddpurchasedetailsComponent,ViewsupportComponent,AdddevicesComponent, AddadjdetailComponent, AddicomedetailComponent,AddrecipedetailComponent,SalesquickviewComponent ,
    AddjournalvoucherComponent,AddpaymentComponent,AddlpoComponent,AddtransferComponent],
})
export class AppModule {


 }
